import { NavItem } from 'common/HorizontalNavPage';
import { PermissionName } from '@utmost.co/enterprise-models';
import { useEnterpriseIntl } from './translations/useEnterpriseIntl';

export enum ENTERPRISE_TAB {
  ROLES = 'roles',
  ORGS = 'orgs',
  LOCATIONS = 'locations',
  COST_CENTERS = 'cost-centers'
}

export const useGetNavItems = () => {
  const intl = useEnterpriseIntl();

  const navItems: NavItem[] = [
    {
      label: intl.roles,
      path: ENTERPRISE_TAB.ROLES,
      'data-test': 'roles__settings__tab',
      permissions: [{ name: 'ROLE', action: 'READ' }],
      icon: 'person_check'
    },
    {
      label: intl.organizations,
      path: ENTERPRISE_TAB.ORGS,
      'data-test': 'orgs__settings__tab',
      permissions: [{ name: 'ORG', action: 'READ' }],
      icon: 'domain'
    },
    {
      label: intl.businessSites,
      path: ENTERPRISE_TAB.LOCATIONS,
      'data-test': 'locations__settings__tab',
      permissions: [{ name: 'LOCATION', action: 'READ' }],
      icon: 'location_on'
    },
    {
      label: intl.costCenters,
      path: ENTERPRISE_TAB.COST_CENTERS,
      'data-test': 'cost-centers__settings__tab',
      permissions: [{ name: 'COST_CENTER', action: 'READ' }],
      icon: 'account_balance'
    }
  ];

  return { navItems };
};

export const PERMISSION_ROUTE_MAP: Partial<PermissionMap> = {
  ROLE: ENTERPRISE_TAB.ROLES,
  ORG: ENTERPRISE_TAB.ORGS
};

type PermissionMap = {
  [E in PermissionName]: ENTERPRISE_TAB;
};
